import { AuthProvider } from "./AuthContext";
import { OrganiceProvider } from "./OrganiceContext";
import { RegisterProvider } from "./RegisterContext";
import { VariableProvider } from "./VariableContext";


const AppProvider = ({ children }) => {
  return (
    <AuthProvider>
        <VariableProvider>
            <RegisterProvider>
                <OrganiceProvider>
                  {children}
                </OrganiceProvider>
            </RegisterProvider>
        </VariableProvider>
    </AuthProvider>
  );
};

export default AppProvider;
